module.exports = __webpack_public_path__ + "img/as_con2_img.14461b68.png";